import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUpcomingCheckins, updateCheckinStatus } from "../../services/checkin";

export const getUpcomingCheckins = createAsyncThunk(
  "checkin/getUpcoming",
  async (daysAhead = 7) => {
    const { data, error } = await fetchUpcomingCheckins(daysAhead);
    if (error) throw error;
    return data;
  }
);

export const markCheckinStatus = createAsyncThunk(
  "checkin/markStatus",
  async ({ reservationId, status, userId }) => {
    const { data, error } = await updateCheckinStatus(reservationId, status, userId);
    if (error) throw error;
    return { reservationId, status, data };
  }
);
